import { createIcon } from './createIcon';

/** Checkbox with a checkmark — scheduled tasks (cron). */
export const TasksIcon = createIcon({
  name: 'TasksIcon',
  viewBox: '0 0 20 20',
  size: 16,
  color: 'var(--text-secondary)',
  children: (
    <>
      <rect
        x="3"
        y="3"
        width="14"
        height="14"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M6.5 10L9 12.5L13.5 7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

export default TasksIcon;
